/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
import Categories from './Categories';
import SubCategories from './SubCategories';

const Badges = () => {
    return (
        <div className='row'>
            <div className='col-12 col-md-6 mb-3'>
                <Categories />
            </div>
            <div className='col-12 col-md-6 mb-3'>
                <SubCategories />
            </div>
        </div>
    );
};

export default Badges;
